import { useMemo } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';

const useRouter = () => {

  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(() => {

    return {

      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      params,
      query: new URLSearchParams(location.search),
      match,
      location,
      history,
    };

  }, [params, match, location, history]);

};

export default useRouter;
